import { render, staticRenderFns } from "./FinanceWeekDetail.vue?vue&type=template&id=0c0f6946&"
import script from "./FinanceWeekDetail.vue?vue&type=script&lang=js&"
export * from "./FinanceWeekDetail.vue?vue&type=script&lang=js&"
import style0 from "./FinanceWeekDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports